import React from "react";
import Image from "../base/image";
import Button from "../base/button";
import Breadcrumb from "../breadcrumb";

const CardGalleryBanner = (cardData, forceH1 = false, breadcrumbSettings) => {
  const {
    title,
    bodyCopy,
    buttonText,
    buttonLink,
    buttonType,
    backgroundColor,
    bannerImage,
    // objectFit
  } = cardData;

  const heading = title ? (
    forceH1 ? <><Breadcrumb settings={breadcrumbSettings} /><h1 className="h2">{title}</h1></> : <h2>{title}</h2>
  ) : "";

  const copy = bodyCopy ? <p className="h4">{bodyCopy}</p> : "";
  const button =
    buttonText && buttonLink ? (
      <Button href={buttonLink} type={`btn-${buttonType ? buttonType : "tertiary-small"}`} text={buttonText} target="_self" />
    ) : (
      ""
    );
  // console.log(cardData, objectFit, objectFit ? "contain" : "cover");
  // <Img className={`${objectFit ? "contain" : "cover"}`} fluid={bannerImage.fluid} objectPosition="50% 50%" alt={bannerImage.title} />
  //force to cover the image, because banner displays on tiles, shouldn't ever needing contain
  const bannerImg = bannerImage ? <Image imageData={bannerImage} alt={bannerImage.title} objectFit={"cover"} /> : "";

  return (
    <div className={`card-gallery--container bg-${backgroundColor}`}>
      <div className="card-gallery--container__content">
        {heading}
        {copy}
        {button}
      </div>
      <div className="card-gallery--container__image">{bannerImg}</div>
    </div>
  );
};

export default CardGalleryBanner;
